<template>
    <div class="layout">
        <m-assembly-table :total="total"
                        :loading="loading"
                        :formData="formData"
                        :columns="columns"
                        :settings="settings"
                        :data="tableData"
                        :tableButtons="tableButtons"
                        @onSubmit="onSubmit"
                        @onPageSizeChange="onPageSizeChange"
                        @onCurrentPageChange="onCurrentPageChange"
                        @onSelectionChange="onSelectionChange"
                        ref="reportForm"
                    >
        </m-assembly-table>
        <Modal v-model="invalidModal"
               :title="$t('失效报告')"
               :width="400"
               :mask-closable="false">
               <span style="font-size: 14px;">{{$t('失效原因')}}：</span><Input v-model="invalidReason"></Input>
               <div slot="footer">
                   <Button type="primary" :loading="loading" @click="invalidReport">{{ $t('确定') }}</Button>
               </div>
        </Modal>
        <Modal v-model="matchModal"
               :title="$t('已匹配送货单')"
               :width="600"
               :mask-closable="false"
        >
            <div style="margin-bottom:10px;">
                <span>{{$t('送货单条码号')}}：</span>
                <Input v-model="matchBarcodeNumber" style="display:inline-block;width:400px;"></Input>
                <Button type="primary" :loading="loading" @click="queryAlreadyMatchReportAndOrder">{{ $t('查询') }}</Button>
            </div>
            <Table columnDrag highlight-row ref="matchTable" border :columns="tableCols" :data="tableData2" :loading="loading"
            size="small"></Table>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import moment from 'moment';
import axios from 'axios';
export default {
    name: 'firstInspectionQueryList',
    components: {
        mAssemblyTable
    },
    data () {
        return {
            currLang: this.$i18n.locale,
            deliveryStatusList: [],
            tableCols: [
                {
                    title: this.$t('送货单条码号'),
                    minWidth: 100,
                    key: 'barcodeNumber',
                    align: 'center'
                },
                {
                    title: this.$t('送货单号'),
                    minWidth: 100,
                    key: 'deliveryNumber',
                    align: 'center'
                },
                {
                    title: this.$t('送货单状态'),
                    minWidth: 70,
                    key: 'deliveryStatus',
                    align: 'center'
                    // render: (h, params) => {
                    //     return h('span', this.deliveryStatusList.find((item) => item.value === params.row.deliveryStatus).label);
                    // }
                },
                {
                    title: this.$t('匹配时间'),
                    minWidth: 110,
                    key: 'creationDate',
                    align: 'center'
                },
                {
                    title: this.$t('匹配数量'),
                    minWidth: 60,
                    align: 'right',
                    key: 'matchCount'
                }
            ],
            tableData2: [],
            reportId: '',
            matchBarcodeNumber: '',
            invalidReason: '',
            matchModal: false,
            invalidModal: false,
            total: 0,
            loading: false,
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'buCode',
                        layout: {
                            span: 8,
                            row: 1
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('事业部不能为空')
                            }
                        },
                        type: 'select',
                        title: this.$t('事业部')
                    },
                    {
                        value: '',
                        field: 'itemCodeStart',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('物料编码从'),
                        isDouble: true,
                        blur: ({value}) => {
                            this.itemCodeSet(value);
                        }
                    },
                    {
                        hide: true,
                        value: '',
                        title: this.$t('至物料编码'),
                        field: 'itemCodeEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        blur: ({value}) => {
                            this.itemCodeSet(value);
                        }
                    },
                    {
                        isDouble: true,
                        value: '',
                        field: 'batchNumberStart',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('批次号从')
                    },
                    {
                        hide: true,
                        value: '',
                        title: '',
                        field: 'batchNumberEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        isDouble: true,
                        value: '',
                        field: 'reportNumberStart',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('批次检验单号从')
                    },
                    {
                        hide: true,
                        value: '',
                        title: '',
                        field: 'reportNumberEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'isValid',
                        layout: {
                            span: 8,
                            row: 2
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.$t('有效'),
                                    value: 'Y'
                                },
                                {
                                    label: this.$t('无效'),
                                    value: 'N'
                                }
                            ]
                        },
                        type: 'select',
                        title: this.$t('是否有效')
                    },
                    {
                        value: moment().subtract(1, 'M'),
                        field: 'creationDateStart',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('创建日期'),
                        placeholder: '',
                        isDouble: true,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('创建日期不能为空')
                            }
                        }
                    },
                    {
                        hide: true,
                        value: new Date(),
                        field: 'creationDateEnd',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {}
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('创建日期不能为空')
                            }
                        }
                    }
                ]
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 40
                    },
                    {
                        title: this.$t('事业部'),
                        key: 'buName',
                        minWidth: 120,
                        align: 'center',
                        render: (h, params) => {
                            let buName = params.row.buName;
                            return h('Tooltip', {
                                props: {
                                    content: buName,
                                    placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, buName);
                        }
                    },
                    {
                        title: this.$t('物料编码'),
                        key: 'itemCode',
                        align: 'center',
                        width: 110
                    },
                    {
                        title: this.$t('物料描述'),
                        key: 'itemDescription',
                        minWidth: 250,
                        render: (h, params) => {
                            return h('Tooltip', {
                                props: {
                                    content: params.row.itemDescription,
                                    placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, params.row.itemDescription);
                        }
                    },
                    {
                        title: this.$t('单位'),
                        key: 'unit',
                        align: 'center',
                        width: 50
                    },
                    {
                        title: this.$t('批次检验单号'),
                        key: 'reportNumber',
                        align: 'center',
                        width: 150
                    },
                    {
                        title: this.$t('批次号'),
                        key: 'batchNumber',
                        align: 'center',
                        width: 120
                    },
                    {
                        title: this.$t('有效日期从'),
                        key: 'validStartTime',
                        align: 'center',
                        width: 130
                    },
                    {
                        title: this.$t('有效日期至'),
                        key: 'validEndTime',
                        align: 'center',
                        width: 130
                    },
                    {
                        title:  this.$t('生产数量'),
                        key: 'checkQuantity',
                        width: 60,
                        align: 'right',
                        render: (h, params) => {
                            return h('div', {
                                style: {
                                    textAlign: 'right'
                                }
                            }, [
                                h('span', {}, params.row.checkQuantity)
                            ]);
                        }
                    },
                    {
                        title: this.$t('可用数量'),
                        key: 'usableQuantity',
                        width: 60,
                        align: 'right',
                        render: (h, params) => {
                            return h('div', {
                                style: {
                                    textAlign: 'right'
                                }
                            }, [
                                h('span', {}, params.row.usableQuantity)
                            ]);
                        }
                    },
                    {
                        title: this.$t('检验员'),
                        key: 'checker',
                        align: 'center',
                        width: 80
                    },
                    {
                        title: this.$t('产地-品牌'),
                        key: 'placeBrand',
                        align: 'center',
                        width: 80
                    },
                    {
                        title: this.$t('检验结果'),
                        key: 'inspectionResult',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: this.$t('是否有效'),
                        key: 'isValid',
                        width: 60,
                        align: 'center',
                    },
                    {
                        title: this.$t('失效原因'),
                        key: 'disableReason',
                        width: 150,
                        render: (h, params) => {
                            return h('Tooltip', {
                                props: {
                                    content: params.row.disableReason,
                                    placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, params.row.disableReason);
                        }
                    },
                    {
                        title: this.$t('创建日期'),
                        key: 'creationDate',
                        align: 'center',
                        width: 130
                    },
                    {
                        title: this.$t('检验标准'),
                        key: 'groupFlagName',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: this.$t('已匹配送货单'),
                        width: 50,
                        fixed: 'right',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.matchQuantity > 0) {
                                return h('Icon', {
                                    props: {
                                        type: 'ios-circle-filled',
                                        size: 27,
                                        color: '#666666'
                                    },
                                    style: {
                                        cursor: 'pointer',
                                        color: '#2d8cf0'
                                    },
                                    nativeOn: {
                                        click: () => {
                                            this.matchModal = true;
                                            this.reportId = params.row.reportNumber;
                                            this.tableData2 = [];
                                            this.matchBarcodeNumber = '';
                                            this.queryAlreadyMatchReportAndOrder();
                                        }
                                    }
                                });
                            }
                        }
                    },
                    {
                        title: this.$t('首检报告查看'),
                        width: 50,
                        fixed: 'right',
                        align: 'center',
                        render: (h, params) => {
                            return h('Icon', {
                                props: {
                                    type: 'ios-circle-filled',
                                    size: 27,
                                    color: '#666666'
                                },
                                style: {
                                    cursor: 'pointer',
                                    color: '#2d8cf0'
                                },
                                nativeOn: {
                                    click: () => {
                                        this.findReportById(params.row);
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('使用系统'),
                        key: 'usingSystem',
                        align: 'center',
                        width: 80,
                    },
                ]
            },
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true
            },
            tableButtons: {
                customButtons: [
                    {
                        name: 'goAdd',
                        label: this.$t('新增'),
                        click: () => {
                            this.$router.push({
                                name: 'firstInspectionQueryAdd'
                            });
                        }
                    },
                    {
                        name: 'goAdd',
                        icon: 'archive',
                        label: this.$t('导出'),
                        click: (button) => {
                            if (this.$refs.reportForm.$refs.queryForm.validateForm()) {
                                this.$set(button, 'loading', true);
                                let params = {
                                    ...this.getFormDataVModel(this.formData.items),
                                    pageIndex: 1,
                                    pageSize: 9999,
                                    vendorCode: this.vendorCode,
                                    language: this.currLang
                                };
                                axios({
                                    url: '/gscint/sxInspection/exportSxInspectionHeader',
                                    method: 'post',
                                    data: params,
                                    headers: { 'content-type': 'application/json; charset=utf-8' },
                                    responseType: 'blob',
                                }).then((res) => {
                                    this.$set(button, 'loading', false);
                                    this.downloadFile(res.data, '首检清单.xlsx');
                                }).catch(() => {
                                    this.$set(button, 'loading', false);
                                    this.showErrorTips();
                                });
                            }
                        }
                    },
                    {
                        name: 'goAdd',
                        label: this.$t('失效单据'),
                        click: () => {
                            if (this.selection.length === 0) {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: this.$t('请勾选需要进行失效的数据')
                                });
                                return false;
                            } else {
                                this.invalidModal = true;
                            }
                        }
                    }
                ]
            },
            tableData: [],
            statusList: [
            ],
            checkResultList: [
            ],
            pageIndex: 1,
            pageSize: 10,
            selection: []
        };
    },
    watch: {
        invalidModal (newVal) {
            if (!newVal) {
                this.invalidReason = '';
            }
        }
    },
    methods: {
        // 获取事业部
        queryBu () {
            axios.get('/gscint/vendor/getOverSeaBuList', {
                params: {
                    SITE: 'Y',
                    ASL: 'N'
                }
            })
            .then((res) => {
                let resData = res.data.data
                if (resData.code == '1') {
                    const data = resData.datas;
                    data.forEach((item) => {
                        item.label = item.buName;
                        item.value = item.buCode;
                    });
                    this.getFormDataItemObj(this.formData.items, 'buCode').options.values = data;
                } else {
                    this.getFormDataItemObj(this.formData.items, 'buCode').options.values = []
                }
            });
        },
        onSubmit (pageIndex, pageSize) {
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.loading = true;
            let formData = this.getFormDataVModel(this.formData.items);
            axios.post('/gscint/sxInspection/querySxInspectionHeader', {
                pageIndex,
                pageSize,
                ...formData,
                vendorCode: this.vendorCode,
                creationDateStart: moment(formData.creationDateStart).format('YYYY-MM-DD 00:00:00'),
                creationDateEnd: moment(formData.creationDateEnd).format('YYYY-MM-DD 23:59:59'),
                isMatch: ''
            })
            .then((res) => {
                this.loading = false;
                this.total = res.data.data.datas.total;
                let list = res.data.data.datas.list;
                for (let i in list) {
                    if (new Date(list[i].validEndTime).getTime() < new Date().getTime()) {
                        list[i].invalidFlag = true;
                    } else {
                        list[i].invalidFlag = false;
                    }
                }
                this.tableData = list;
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        onPageSizeChange (page, pageSize) {
            this.onSubmit(page, pageSize);
        },
        onCurrentPageChange (page, pageSize) {
            this.onSubmit(page, pageSize);
        },
        onSelectionChange (selection) {
            this.selection = selection;
        },
        // 批量失效报告
        invalidReport () {
            if (!this.invalidReason) {
                this.$Modal.error({
                    content: this.$t('失效原因不能为空')
                });
                return false;
            }
            
            let errorReportList = [];
            let idList = []
            this.selection.forEach((item) => {
                if (new Date(item.validStartTime).getTime() > new Date().getTime() || new Date(item.validEndTime).getTime() < new Date().getTime()) {
                    errorReportList.push(item.reportNumber);
                } else {
                    idList.push(item.id);
                }
            });
            if (errorReportList.length) {
                this.$Modal.error({
                    content: `${this.$t('报告编号')} ${errorReportList.toString()} ${this.$t('非有效报告，不允许失效处理')}`
                });
                return false;
            }
            this.loading = true;
            axios.post('/gscint/sxInspection/invalidReport', {
                idList,
                reason: this.invalidReason
            })
            .then((res) => {
                this.loading = false;
                if (res.data.data.code === '1') {
                    this.selection = [];
                    this.$Modal.success({
                        title: this.$t('common.warn'),
                        content: this.$t('报告已失效')
                    });
                    this.onSubmit(this.pageIndex, this.pageSize);
                    this.invalidModal = false;
                } else {
                    this.showErrorTips('loading', res.data.data.msg);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 查看报告
        findReportById (row) {
            this.$router.push({
                path: '/qualityManagement/shipmentInspectionRead',
                query: {
                    id: row.id,
                    readOnly: true
                }
            });
        },
        // 查询已匹配的送货单
        queryAlreadyMatchReportAndOrder () {
            this.loading = true;
            axios.get(`/gscint/sxInspection/queryDeliveryOrder?reportNumber=${this.reportId}&barcodeNumber=${this.matchBarcodeNumber}`, {})
            .then((res) => {
                this.loading = false;
                let resData = res.data.data
                if (resData.code == '1') {
                    this.tableData2 = resData.datas || [];
                } else {
                    this.tableData2 = []
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /** 获取状态 */
        getStatusByCode: function () {
            let url = '/gscint/sys/sysParam/queryDictionaryData' + '?dictCode=DELIVERYSTATUS&isValid=Y';
            axios.get(url, this.postHeaderConf).then(
                res => {
                    let rep = res.data;
                    if (rep.success === true) {
                        this.deliveryStatusList = rep.data;
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: rep.msg
                        });
                    }
                }
            ).catch(() => {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        
        itemCodeSet (value) {
            ['itemCodeStart', 'itemCodeEnd'].forEach((item) => {
                let obj = this.getFormDataItemObj(this.formData.items, item);
                if (value) {
                    if (!obj.value) {
                        obj.value = value;
                    }
                } else {
                    if (obj.value) {
                        obj.value = '';
                    }
                }
            });
        }
    },
    mounted () {
        this.queryBu();
        this.getStatusByCode();
    }
};
</script>
<style lang="less" scoped>
.layout {
  background: #FFF;
}
</style>